import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../style/WhySteelx.css";
import { FaClock, FaCogs, FaCheckCircle, FaUsers } from "react-icons/fa";

const WhySteelx = () => {
  useEffect(() => {
      AOS.init();
    }, [])
  return (
    <div className="why-ess-container">
      <h2 className="why-title">
        WHY <span className="highlight">SteelX?</span>
      </h2>
      <div className="features">
        <div className="feature-box" data-aos="zoom-in" data-aos-duration="1000">
          <FaClock className="feature-icon" />
          <p>Always On Time</p>
        </div>
        <div className="feature-box" data-aos="zoom-in" data-aos-duration="1000">
          <FaCogs className="feature-icon" />
          <p>Professional Services</p>
        </div>
        <div className="feature-box" data-aos="zoom-in" data-aos-duration="1000">
          <FaCheckCircle className="feature-icon" />
          <p>We Deliver Quality</p>
        </div>
        <div className="feature-box" data-aos="zoom-in" data-aos-duration="1000">
          <FaUsers className="feature-icon" />
          <p>Total Customer Satisfaction</p>
        </div>
      </div>
    </div>
  );
};

export default WhySteelx;
